import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { StyledMapPlaceholderNoData } from "@ryde/controls";
import { RouteBlock } from "@ryde/layout";
import {
  apiDataFetchingAtom,
  getRideRouteInfo,
  IRideRoute,
  Log,
  MapRouteBlockTypeEnum,
  selectedRidesSelector,
} from "@ryde/shared";

interface IKanbanMapProps {
  routeBlockType: MapRouteBlockTypeEnum;
}

export const KanbanMap: FC<IKanbanMapProps> = ({ routeBlockType }) => {
  const selectedRides = useRecoilValue(selectedRidesSelector);
  const dataLoading = useRecoilValue(apiDataFetchingAtom);
  const selectedRidesRoutes: IRideRoute[] = useMemo(() => {
    Log.debug(
      "Kanban routes for selected rides for map re-evaluated",
      selectedRides,
    );
    return selectedRides.map(getRideRouteInfo);
  }, [selectedRides]);

  const isMapShown = useMemo(() => {
    return !dataLoading;
  }, [dataLoading]);

  return (
    <>
      {isMapShown && (
        <RouteBlock
          routes={selectedRidesRoutes}
          routeBlockType={routeBlockType}
        />
      )}
      {!isMapShown && <StyledMapPlaceholderNoData />}
    </>
  );
};
